import React from 'react';
import { Button, Modal, Row } from 'react-bootstrap-5';

import { callListUrl, CALL_LISTS_SHOW } from '../../../helpers/prospect_api';
import type { CallListImportStatus } from 'bundles/connect/types';

type Props = {
  callListData: CallListImportStatus;
  callListId: number;
  handleClose: () => void;
}

export default function ImportModalAddressList({
  callListData,
  callListId,
  handleClose,
}: Props) {
  return (
    <>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title as="h5">Missing Properties</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <p>
            These are the properties we could not match from your list.
            You can try performing individual searches and add them to this list manually.
          </p>
        </Row>
        <div className="bg-light rounded p-2 mb-2 overflow-auto border" style={{ maxHeight: '500px' }}>
          {callListData.noPropertyAddresses.map((address, index) => (
            <div className="d-flex align-items-center justify-content-between" key={index} >
              <div>
                <p className="m-2">
                  {address.address}{address.state && `, ${address.state}`}{address.zip && `, ${address.zip}`}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="text-primary" onClick={handleClose}>
          Close
        </Button>
        <Button href={callListUrl(CALL_LISTS_SHOW, callListId)} variant="secondary">
          View List
        </Button>
      </Modal.Footer>
    </>
  );
}
